import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './columns.css';

const Columns = ({ children, spacing }) => (
  <Container spacing={spacing}>{children}</Container>
);

Columns.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Columns;
